import { render, staticRenderFns } from "./BuildDeposit.vue?vue&type=template&id=7c8b27f6&scoped=true&"
import script from "./BuildDeposit.vue?vue&type=script&lang=js&"
export * from "./BuildDeposit.vue?vue&type=script&lang=js&"
import style0 from "./BuildDeposit.vue?vue&type=style&index=0&id=7c8b27f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8b27f6",
  null
  
)

export default component.exports